module.exports = __webpack_public_path__ + "img/big-pdf.f4bb4432.png";